import ToolbarLink from "../custom/ToolbarLink";
import ToolbarVideo from "../custom/ToolbarVideo";
import ToolbarEmoji from "../custom/ToolbarEmoji";
import ToolbarImage from "../custom/ToolbarImage";
import ToolbarButton from "../custom/ToolbarButton";
import ToolbarItem from "../ToolbarItem";
import { useEditorContext } from "../../Wysiwyg";

const InsertToolbarGroup = () => {
  const { editor } = useEditorContext();
  return (
    <>
      <ToolbarItem
        id="hr-toolbar-item"
        tooltip="Elválasztó vonal"
        active={false}
        onToggle={() => editor.chain().focus().setHorizontalRule().run()}
        icon={<i className="fa fa-minus" aria-hidden="true" />}
      />
      <ToolbarLink />
      <ToolbarVideo />

      <ToolbarImage />
      <ToolbarImage
        icon={<i className="fa fa-indent" aria-hidden="true" />}
        imgProps={{ class: "tiptap-float-left" }}
        label="Kép balra lebegtetett szöveggel"
      />
      <ToolbarImage
        icon={<i className="fa fa-outdent" aria-hidden="true" />}
        imgProps={{ class: "tiptap-float-right" }}
        label="Kép jobbra lebegtetett szöveggel"
      />

      <ToolbarEmoji />
      <ToolbarButton />
    </>
  );
};

export default InsertToolbarGroup;
